export const getSales = state => state.salesContent;
export const getPaperReceipt = state => state.salesContent.paperReceipt;
export const getLoadingPaperReceipt = state => state.salesContent.isLoadingPaperReceipt;
export const getprintTicketData = state => state.salesContent.printTicket;
export const getSingleSale = state => state.salesContent.singleSalesData;

